import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import JoinUsForm from "./JoinUsForm";
import StudentAmbassadorForm from "./StudentAmbassadorForm";
import AdminContactUsForm from "./AdminContactUsForm";
import ThankYouPage from "./ThankYouPage";
import SubmissionReceived from "./SubmissionReceived"; // Import the new component
import BackgroundImage from "../../assets/images/backGround.webp";
import LogoImage from "../../assets/images/scholarty-02-white-no-border.png";

const JoinUsPage = () => {
  const [searchParams] = useSearchParams();
  const formType = searchParams.get("form");
  const [isSubmitted, setIsSubmitted] = useState(false); // Add state to track submission

  // This function will be called by the child forms on success
  const handleSuccess = () => {
    setIsSubmitted(true);
  };

  const renderForm = () => {
    // If a form has been submitted, show the success component
    if (isSubmitted) {
      return <SubmissionReceived />;
    }

    // Otherwise, show the correct form and pass the success handler to it
    switch (formType) {
      case "ambassador":
        return <StudentAmbassadorForm onSuccess={handleSuccess} />;
      case "admin":
        return <AdminContactUsForm onSuccess={handleSuccess} />;
      case "thankyou":
        return <ThankYouPage />;
      default:
        return <JoinUsForm onSuccess={handleSuccess} />;
    }
  };

  // Adjust max width 
  // All forms and the submission component use max-w-3xl. ThankYouPage is wider.
  const formMaxWidth = formType === "thankyou" ? "max-w-5xl" : "max-w-3xl";

  return (
    <div className="flex flex-col md:flex-row w-full h-screen overflow-hidden">
      {/* Left side - Image with overlay */}
      <div className="relative w-full md:basis-[30%] h-[200px] md:h-full">
        <img
          src={BackgroundImage}
          alt="Join Us"
          className="absolute inset-0 object-cover w-full h-full"
        />
        {/* Dark overlay/shader */}
        <div className="absolute inset-0 bg-black/30"></div>

        {/* Logo container */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white z-10">
          <div className="flex justify-center items-center w-full">
            <Link to="/" className="inline-block cursor-pointer">
              <img
                src={LogoImage}
                alt="Scholarty"
                className="w-[125px] sm:w-[200px] md:w-[150px] lg:w-[200px] xl:w-[300px] h-auto mb-3"
              />
            </Link>
          </div>
        </div>
      </div>

      {/* Vertical Divider */}
      <div className="hidden md:block w-[12px] h-full bg-[#5379F6]"></div>

      {/* Right side - Form */}
      <div className="w-full md:basis-[70%] h-full flex">
        <div
          className={`w-full h-full flex items-center justify-center overflow-y-auto p-4 md:p-8`}
        >
          <div className={`w-full ${formMaxWidth} my-auto`}>{renderForm()}</div>
        </div>
      </div>
    </div>
  );
};

export default JoinUsPage;
